var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7L9 5.33333C9 4.04456 10.0552 3 11.3571 3L17.6429 3C18.9448 3 20 4.04456 20 5.33333L20 14.6667C20 15.9554 18.9448 17 17.6429 17L15 17",
    stroke: "#0F0C18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.6667L4 9.33333C4 8.04456 5.05522 7 6.35714 7L12.6429 7C13.9448 7 15 8.04456 15 9.33333L15 18.6667C15 19.9554 13.9448 21 12.6429 21L6.35714 21C5.05521 21 4 19.9554 4 18.6667Z",
    stroke: "#0F0C18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.d09d08059fe5df5f0e399b4e3683fe80.svg";
export { ForwardRef as ReactComponent };